import { useUIStore } from '../stores/uiStore';
import es from './es.json';
import en from './en.json';

const translations = { es, en };

type NestedObject = { [key: string]: string | NestedObject };

function getNestedValue(obj: NestedObject, path: string): string {
  const keys = path.split('.');
  let result: string | NestedObject = obj;
  for (const key of keys) {
    if (typeof result === 'object' && result !== null && key in result) {
      result = result[key];
    } else {
      return path;
    }
  }
  return typeof result === 'string' ? result : path;
}

export function useTranslation() {
  const language = useUIStore((state) => state.language);
  const currentTranslations = translations[language] || translations.es;

  const t = (key: string, params?: Record<string, string | number>): string => {
    let text = getNestedValue(currentTranslations as NestedObject, key);
    if (params) {
      Object.entries(params).forEach(([paramKey, value]) => {
        text = text.replace(new RegExp(`\\{\\{${paramKey}\\}\\}`, 'g'), String(value));
      });
    }
    return text;
  };

  return { t, language };
}
